// @ts-nocheck

import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { clearSearch } from '../../actions/search';
import { clearPreferences } from '../../actions/user';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';
import useOpenBoomView from '../../modules/boom/hooks/useOpenBoomView';
import { selectUserBankroll } from '../../selectors/user.selector';

import NavigationDesktopBar from './NavigationDesktopBar';
import selectNavigationDesktopBarProps from './NavigationDesktopBar.selector';

const NavigationDesktopBarContainer = (ownProps: unknown) => {
  const dispatch = useDispatch();
  const { history, location } = useRouter();
  const openBoomView = useOpenBoomView();

  const actions = useMemo(
    () => ({
      clearPreferences,
      clearSearch,
    }),
    [],
  );

  const actionsProps = useBindActionsCreator(actions);

  const selectorProps = useMemo(
    () => ({ history, location, dispatch, openBoomView, ...actionsProps }),
    [history, location, dispatch, openBoomView, actionsProps],
  );
  const selectedProps = useSelector((state) => selectNavigationDesktopBarProps(state, selectorProps));

  const otherProps = useSelector(selectUserBankroll);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, actionsProps, otherProps });

  return <NavigationDesktopBar {...enhancedProps} />;
};

export default NavigationDesktopBarContainer;
